<template>
  <div class="combined-wrapper" :class="pollPositionClass">
    <div class="poll-qrcode-unit" ref="unit" :style="fitStyle">
      <div v-if="hasValidQRCode" class="qrcode-section">
        <CardTarjaEnqueteCopaTVFechadaQRCODE
          :item="item"
          :posicaoEnquete="posicaoEnquete"
          :isFullScreen="isFullScreen"
          :combined="true"
          @qrcode-error="onQRCodeError"
        />
      </div>

      <div class="poll-section">
        <CardTarjaEnqueteCopaTVFechada
          :item="item"
          :posicaoEnquete="posicaoEnquete"
          :isFullScreen="isFullScreen"
          :hideTitle="hideTitle"
          :hideOptionTitle="hideOptionTitle"
          :combined="hasValidQRCode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CardTarjaEnqueteCopaTVFechada from './CardTarjaEnqueteCopaTVFechada.vue';
import CardTarjaEnqueteCopaTVFechadaQRCODE from './CardTarjaEnqueteCopaTVFechadaQRCODE.vue';

export default {
  name: 'CardTarjaEnqueteCopaTVFechadaWithQRCode',
  components: {
    CardTarjaEnqueteCopaTVFechada,
    CardTarjaEnqueteCopaTVFechadaQRCODE,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideOptionTitle: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      fitScale: 1,
    };
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    pollPositionClass() {
      const positionMap = {
        'esquerda': 'poll-left',
        'direita': 'poll-right',
        'centro': 'poll-center'
      };
      return positionMap[this.posicaoEnquete] || 'poll-left';
    },
    fitStyle() {
      if (this.fitScale >= 1) return {};
      const originX = this.posicaoEnquete === 'direita'
        ? 'right'
        : this.posicaoEnquete === 'centro'
          ? 'center'
          : 'left';
      return {
        transform: `scale(${this.fitScale})`,
        transformOrigin: `${originX} bottom`,
      };
    }
  },
  mounted() {
    this.$nextTick(this.computeFit);
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.computeFit());
      this.resizeObserver.observe(this.$refs.unit);
    }
    window.addEventListener('resize', this.computeFit);
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.computeFit);
  },
  methods: {
    // Scale the whole QR+poll unit down so it never exceeds the broadcast safe
    // width (e.g. 6 options with flags). offsetWidth is the untransformed layout
    // width, so reading it while scaled is stable (no feedback loop).
    computeFit() {
      const wrapper = this.$el;
      const unit = this.$refs.unit;
      if (!wrapper || !unit) return;
      const style = window.getComputedStyle(wrapper);
      const padX = parseFloat(style.paddingLeft || 0) + parseFloat(style.paddingRight || 0);
      const available = wrapper.clientWidth - padX;
      const natural = unit.offsetWidth;
      if (!natural || available <= 0) return;
      const next = natural > available ? available / natural : 1;
      if (Math.abs(next - this.fitScale) > 0.002) {
        this.fitScale = next;
      }
    },
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
.combined-wrapper {
  width: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  /* Broadcast safe area: keep the unit off the screen edges so the configured
     position (esquerda/centro/direita) is honored with margin, not flush.
     Equal 35px sides so wide (many-option) enquetes sit symmetrically. */
  padding: 0 35px 44px 35px;
  box-sizing: border-box;

  &.poll-left {
    justify-content: flex-start;
  }

  &.poll-center {
    justify-content: center;
  }

  &.poll-right {
    justify-content: flex-end;
  }
}

.poll-qrcode-unit {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: relative;
}

.qrcode-section {
  z-index: 10;
  margin-right: -71px; /* Adjust overlap so the chevrons meet seamlessly and hide the straight edge */
  margin-bottom: 10px; /* To align with the base margin of copa-tv-fechada-container */
}

.poll-section {
  z-index: 1;
}

::v-deep .copa-tv-fechada-container {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
